/**
 * ⑩ 板块轮动对比卡。 Figma：94103:23825
 */

import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { cn } from "utils";
import { SignalCardShell } from "./SignalCardShell";
import type { SignalCardAssetProps } from "./types";

export interface AssetSectorShiftCardProps extends SignalCardAssetProps {
  fromSectorName: string;
  fromSectorChange: string;
  toSectorName: string;
  toSectorChange: string;
}

export const AssetSectorShiftCard: React.FC<AssetSectorShiftCardProps> = ({
  fromSectorName,
  fromSectorChange,
  toSectorName,
  toSectorChange,
  ...asset
}) => {
  const fromNegative = fromSectorChange.trim().startsWith("-");
  const toPositive = toSectorChange.trim().startsWith("+");

  return (
    <SignalCardShell {...asset}>
      <div className="flex items-center gap-2">
        <div className="flex min-w-0 flex-1 flex-col items-center">
          <span className="body_s text-content_tertiary">{fromSectorName}</span>
          <span
            className={cn("headline_regular_l", {
              "text-content_accent2_primary": fromNegative,
              "text-content_accent1_primary": !fromNegative,
            })}
          >
            {fromSectorChange}
          </span>
        </div>
        <div
          className="flex gap-[6px] shrink-0 items-center text-content_brand_primary"
          aria-hidden
        >
          <OspIcons
            name="compass"
            size={12}
            className="text-content_brand_quaternary"
          />
          <OspIcons
            name="compass"
            size={12}
            className="text-content_brand_tertiary"
          />
          <OspIcons
            name="compass"
            size={12}
            className="text-content_brand_primary"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col items-center">
          <span className="body_s text-content_tertiary">{toSectorName}</span>
          <span
            className={cn("headline_regular_l", {
              "text-content_accent1_primary": toPositive,
              "text-content_accent2_primary": !toPositive,
            })}
          >
            {toSectorChange}
          </span>
        </div>
      </div>
    </SignalCardShell>
  );
};
